import angular from 'angular';

(function() {
  'use strict';

  angular.module('app.principal').controller('InvoiceSectionCtrl', InvoiceSectionCtrl);

  InvoiceSectionCtrl.$inject = ['$uibModal', 'InvoiceParamSvc', 'AuthSvc'];

  function InvoiceSectionCtrl($uibModal, InvoiceParamSvc, AuthSvc) {
    var vm = this;

    // Data API
    vm.collapseTable = true;

    // Function API
    vm.addItem = addItem;
    vm.removeFn = removeFn;
    vm.changeFilter = changeFilter;
    vm.isEditAuthorized = AuthSvc.isEditAuthorized();

    ////////////////////////

    vm.$onInit = function() {
      vm.collapseTable = vm.initClosed;
    };

    function addItem(typeSection) {
      $uibModal
        .open({
          component: 'ModalAddAttribute',
          resolve: {
            attributes: function() {
              return InvoiceParamSvc.filterDataModal(vm.fullAttributes, vm.invoiceAttributes, typeSection);
            },
            typeSection: function() {
              return typeSection;
            },
            nbAttribute: function() {
              return vm.sectionAttributes.length;
            },
            filters: function() {
              return vm.filters;
            }
          }
        })
        .result.then(_closeModal, function() {});
    }

    function _closeModal(addedAttributes) {
      vm.addFn({ items: addedAttributes, section: vm.typeSection });
    }

    function removeFn(attribute) {
      vm.removeItemFn({ item: attribute });
    }

    function changeFilter(data) {
      // Si LAD et Saisi sont sélectionnées on affiche tout
      // sinon on affiche selon la valeur de la checkbox
      return (
        (vm.filters.lad && vm.filters.saisie) || (vm.filters.lad && data.lad) || (vm.filters.saisie && data.saisie)
      );
    }
  }
})();
